export default __webpack_public_path__ + "static/media/92e7275a050a4e1e7f89bd19a0b939bf1600258849290.1fbefda2.webp";